import { DEFAULT_PAGE_SIZE } from "@/shared/constants/pagination";
import { parseAsInteger, useQueryStates } from "nuqs";

export interface PaginationState {
  pageIndex: number;
  pageSize: number;
}

export function useDataTablePagination(defaultPageSize = DEFAULT_PAGE_SIZE) {
  // Pagination state with nuqs
  const paginationStates = {
    pageIndex: parseAsInteger
      .withDefault(1)
      .withOptions({ clearOnDefault: false }),
    pageSize: parseAsInteger
      .withDefault(defaultPageSize)
      .withOptions({ clearOnDefault: false }),
  };

  const paginationStatesOptions = {
    urlKeys: {
      pageIndex: "page",
      pageSize: "pageSize",
    },
  };

  const [rawPagination, setRawPagination] = useQueryStates(
    paginationStates,
    paginationStatesOptions,
  );

  // Convert 1-based URL index to 0-based table index
  const pagination: PaginationState = {
    ...rawPagination,
    pageIndex: rawPagination.pageIndex - 1,
  };

  const setPagination = (
    updaterOrValue:
      | PaginationState
      | ((prev: PaginationState) => PaginationState),
  ) => {
    const updatedPagination =
      typeof updaterOrValue === "function"
        ? updaterOrValue(pagination)
        : updaterOrValue;

    if (
      updatedPagination.pageIndex === pagination.pageIndex &&
      updatedPagination.pageSize === pagination.pageSize
    ) {
      return;
    }

    // Convert 0-based table index to 1-based URL index
    setRawPagination({
      ...updatedPagination,
      pageIndex: updatedPagination.pageIndex + 1,
    });
  };

  return {
    pagination,
    setPagination,
  };
}
